// extracted by mini-css-extract-plugin
export var backgroundImage = "Herospace-module--background-image--f153c";
export var content = "Herospace-module--content--b622d";
export var contentBox = "Herospace-module--content-box--0b271";
export var contentBoxFooter = "Herospace-module--content-box-footer--e89ec";
export var header = "Herospace-module--header--9723c";
export var herospace = "Herospace-module--herospace--f1507";
export var subtitle = "Herospace-module--subtitle--00901";
export var title = "Herospace-module--title--04fe0";